/**
 * Heading Component - Themed typography headings
 */

import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Heading = ({
  children,
  level = 2, // 1-6
  variant = 'default', // 'default', 'primary', 'light'
  className = '',
  style = {}
}) => {
  const { theme } = useTheme();

  const getFontSize = () => {
    switch (level) {
      case 1:
        return theme.typography.sizes['4xl'];
      case 2:
        return theme.typography.sizes['3xl'];
      case 3:
        return theme.typography.sizes['2xl'];
      case 4:
        return theme.typography.sizes.xl;
      case 5:
        return theme.typography.sizes.lg;
      case 6:
        return theme.typography.sizes.base;
      default:
        return theme.typography.sizes['3xl'];
    }
  };

  const getColor = () => {
    switch (variant) {
      case 'primary':
        return theme.colors.primary;
      case 'light':
        return theme.colors.textSecondary;
      default:
        return theme.colors.textPrimary;
    }
  };

  const baseStyles = {
    color: getColor(),
    fontSize: getFontSize(),
    fontWeight: theme.typography.weights.bold,
    lineHeight: 1.2,
    marginBottom: theme.spacing.md,
    ...style
  };

  const CustomTag = `h${level}`;

  return (
    <CustomTag className={`heading ${className}`} style={baseStyles}>
      {children}
    </CustomTag>
  );
};

export default Heading;